
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/state/[slug]",
      function () {
        return require("private-next-pages/advocacy/state/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/state/[slug]"])
      });
    }
  